import { GET_ORG_EMAIL_SETTINGS, UPDATE_ORG_EMAIL_SETTINGS } from '../../types'

const initialState = {
  welcomeEmailTemplate: [],
  alertEmailTemplate: [],
  sourceEmailAddress: '',
  sourceEmailName: ''
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORG_EMAIL_SETTINGS: return {
      ...state,
      welcomeEmailTemplate: action.payload.welcomeEmailTemplate,
      alertEmailTemplate: action.payload.alertEmailTemplate,
      sourceEmailAddress: action.payload.sourceEmailAddress,
      sourceEmailName: action.payload.sourceEmailName
    }
    case UPDATE_ORG_EMAIL_SETTINGS: return {
      ...state,
      welcomeEmailTemplate: action.payload.welcomeEmailTemplate,
      alertEmailTemplate: action.payload.alertEmailTemplate,
      sourceEmailAddress: action.payload.sourceEmailAddress,
      sourceEmailName: action.payload.sourceEmailName
    }
    default: return { ...state }
  }
}
